import { AdvancingFilesPanel } from "advancing/files/AdvancingFilesPanel";
import { getApproveSidePanelQuery } from "advancingapprove/utils";
import React from "react";
import { useLoaderData } from "react-router";

export const FilesTab = () => {
  const { advancingSession } = useLoaderData<server.viewmodel.AdvancingApproveFrontModel>();
  const { advancingSessionId } = advancingSession;

  return <AdvancingFilesPanel
    advancingSessionId={advancingSessionId}
    instruction={{ advancingSessionId }}
    sidePanelQueryKey={getApproveSidePanelQuery(advancingSessionId).queryKey}
  />;
};
